import type React from 'react';

import { PublicAuthRoutesWrapper } from '@xarvio/xfm-auth-remote-source/PublicAuthRoutesWrapper';

export const loadPublicAuthRoutesWrapper = async (): Promise<{
  default: React.ComponentType;
}> => {
  return {
    default: PublicAuthRoutesWrapper,
  };
};
